import moment from 'moment';
// usage: {{dateObj | date}}
export default function format(date) {
  if (!date) return date;
  return moment(date).format('MMMM Do YYYY, h:mm:ss a');
}
